import {Component} from '@angular/core';
import {UrlService} from '../../../services/url.service';
import {SettingsParcelsService} from '../../../services/settings-parcels.service';

declare const toastr: any;
declare const $: any;

@Component({
    selector: 'settings-parcels-list',
    templateUrl: './settings-parcels-list.component.html',
    styleUrls: ['./settings-parcels-list.component.scss']
})
export class SettingsParcelsListComponent {

    constructor(
        public urlService: UrlService,
        public settingsParcelsService: SettingsParcelsService
    ) {}

    orderBy(orderBy: string, $event) {
        if (this.settingsParcelsService.corporations.total < 2) return;
        this.urlService.orderBy(orderBy, $event);
    }

    toggleCheck(selectedItem): void {
        this.settingsParcelsService.emptyNotificationArrays();
        if (selectedItem.checked && this.settingsParcelsService.selectedItemData)
            this.settingsParcelsService.toggleDetailedView(null, false);
        else
            this.settingsParcelsService.toggleDetailedView(selectedItem, true);
    }

    getBuildingNameById(id): string {
        let name = '';

        this.settingsParcelsService.buildings.forEach(building => {
            if(building.id == id)
                name = building.name;
        });

        return name;
    }

    showHint(e) {
        e.stopPropagation();
        const $td = $(e.target).closest('.table-hint-td');
        if ($td.hasClass('active'))
            $td.removeClass('active');
        else {
            $('.table-hint-td').removeClass('active');
            $td.addClass('active');
        }
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/settings-parcels/settings-parcels-list/settings-parcels-list.component.ts